/**
 * Metadata dictionary providing high-fidelity Danish alt text, titles and descriptions
 * for images used across the Entreprenør Jan Nørgaard ApS website.
 * Supports both new SEO-optimized filenames and legacy filenames.
 */
export const MEDIA_REGISTRY = {
  // Brand & Logo
  'entreprenoer-jan-noergaard-logo.png': {
    alt: 'Entreprenør Jan Nørgaard ApS logo - Autoriseret Kloakmester & Entreprenør',
    title: 'Entreprenør Jan Nørgaard ApS',
    description: 'Officielt firmalogo for Entreprenør Jan Nørgaard ApS, autoriseret kloakmester og entreprenør.',
  },
  'imgi-1-logo-5.png': {
    alt: 'Entreprenør Jan Nørgaard ApS logo - Autoriseret Kloakmester & Entreprenør',
    title: 'Entreprenør Jan Nørgaard ApS',
    description: 'Officielt firmalogo for Entreprenør Jan Nørgaard ApS, autoriseret kloakmester og entreprenør.',
  },

  // Jan Nørgaard profil
  'jan-norgaard-entreprenor.jpg': {
    alt: 'Jan Nørgaard - Ejer og autoriseret kloakmester hos Entreprenør Jan Nørgaard ApS',
    title: 'Jan Nørgaard - Autoriseret Kloakmester',
    description: 'Jan Nørgaard, grundlægger og autoriseret kloakmester med mere end 20 års praktisk erfaring.',
  },

  // Nedbrydning & jordarbejde
  'gravemaskine-nedbrydning-jordarbejde.jpg': {
    alt: 'Gravemaskine udfører nedbrydnings- og jordarbejde på byggeplads',
    title: 'Entreprenørarbejde og nedbrydning med gravemaskine',
    description: 'Tungt entreprenørmateriel og gravemaskine i arbejde med nedbrydning og terrænregulering.',
  },
  'imgi-5-nedbrydning-3-500x375.jpg': {
    alt: 'Gravemaskine udfører nedbrydnings- og jordarbejde på byggeplads',
    title: 'Entreprenørarbejde og nedbrydning med gravemaskine',
    description: 'Tungt entreprenørmateriel og gravemaskine i arbejde med nedbrydning og terrænregulering.',
  },

  // Kloakspuling & TV-inspektion
  'kloakspuling-og-tv-inspektion.jpg': {
    alt: 'Specialudstyr og spuleslange til autoriseret kloakspuling og TV-inspektion',
    title: 'Kloakspuling og TV-inspektion udstyr',
    description: 'Professionelt udstyr til højtryksspuling og TV-inspektion af rørledninger, kloakker og brønde.',
  },
  'imgi-3-spuling-og-tv-inspektion.jpg': {
    alt: 'Specialudstyr og spuleslange til autoriseret kloakspuling og TV-inspektion',
    title: 'Kloakspuling og TV-inspektion udstyr',
    description: 'Professionelt udstyr til højtryksspuling og TV-inspektion af rørledninger, kloakker og brønde.',
  },
  'tv-inspektion-af-kloakroer.jpg': {
    alt: 'Inspektionskamera til præcis TV-inspektion af kloakrør og stikledninger',
    title: 'TV-inspektion med farvekamera',
    description: 'Specialkamera til lokalisering af rørbrud, rotteangreb, rødder og tilstopninger i kloaksystemer.',
  },
  'imgi-4-tv-inspektion.jpg': {
    alt: 'Inspektionskamera til præcis TV-inspektion af kloakrør og stikledninger',
    title: 'TV-inspektion med farvekamera',
    description: 'Specialkamera til lokalisering af rørbrud, rotteangreb, rødder og tilstopninger i kloaksystemer.',
  },

  // Udgravning
  'udgravning-minigraver-jordarbejde.jpg': {
    alt: 'Minigraver i færd med præcis udgravning i terræn til olietank og jordarbejde',
    title: 'Præcisionsudgravning med gravemaskine',
    description: 'Udgravningsarbejde i haven med minigraver for skånsom og præcis etablering af underjordiske installationer.',
  },
  'imgi-12-udgravning-til-olietank.jpg': {
    alt: 'Minigraver i færd med præcis udgravning i terræn til olietank og jordarbejde',
    title: 'Præcisionsudgravning med gravemaskine',
    description: 'Udgravningsarbejde i haven med minigraver for skånsom og præcis etablering af underjordiske installationer.',
  },

  // Støbearbejde & kloak
  'stoebearbejde-fundament-og-kloak.jpg': {
    alt: 'Færdigstøbt betonfundament og sokkel med kloakrør og klargjort sandpude',
    title: 'Støbearbejde, fundament og kloakføring',
    description: 'Professionelt støbt fundament med præcis sokkelhøjde, indstøbte afløbsrør og vibreret sandpude.',
  },
  'imgi-13-stoebearbejde-kloak-2.jpg': {
    alt: 'Færdigstøbt betonfundament og sokkel med kloakrør og klargjort sandpude',
    title: 'Støbearbejde, fundament og kloakføring',
    description: 'Professionelt støbt fundament med præcis sokkelhøjde, indstøbte afløbsrør og vibreret sandpude.',
  },
  'armering-og-stoebearbejde-fundament.jpg': {
    alt: 'Jernarmering og forskalling til støbning af kraftigt betonfundament',
    title: 'Armering og støbearbejde til fundament',
    description: 'Håndværksmæssigt korrekt jernarmering og støbning til bærende fundamenter og sokler.',
  },
  'imgi-4-stoebearbejde-5-375x500.jpg': {
    alt: 'Jernarmering og forskalling til støbning af kraftigt betonfundament',
    title: 'Armering og støbearbejde til fundament',
    description: 'Håndværksmæssigt korrekt jernarmering og støbning til bærende fundamenter og sokler.',
  },

  // Faskine & afløb
  'faskine-nedsivning-af-regnvand.jpg': {
    alt: 'Nedgravning og etablering af faskine i geotekstil til lokal afledning af regnvand',
    title: 'Regnvandsfaskine til LAR-løsning',
    description: 'Etablering af regnvandsfaskine for effektiv og miljøvenlig nedsivning af tag- og overfladevand.',
  },
  'imgi-14-faskine-til-regnvand.jpg': {
    alt: 'Nedgravning og etablering af faskine i geotekstil til lokal afledning af regnvand',
    title: 'Regnvandsfaskine til LAR-løsning',
    description: 'Etablering af regnvandsfaskine for effektiv og miljøvenlig nedsivning af tag- og overfladevand.',
  },
  'autoriseret-kloakarbejde-roerlaegning.jpg': {
    alt: 'Autoriseret kloakarbejde med udgravning, PVC-afløbsrør og korrekt fald',
    title: 'Autoriseret rørlægning og kloakarbejde',
    description: 'Installation af nye kloakledninger og brønde udført af autoriseret kloakmester efter gældende DS432 norm.',
  },
  'imgi-16-kloark.jpg': {
    alt: 'Autoriseret kloakarbejde med udgravning, PVC-afløbsrør og korrekt fald',
    title: 'Autoriseret rørlægning og kloakarbejde',
    description: 'Installation af nye kloakledninger og brønde udført af autoriseret kloakmester efter gældende DS432 norm.',
  },

  // Sandpude
  'opbygning-af-sandpude-til-byggeri.jpg': {
    alt: 'Komprimering og laseropbygning af stabil sandpude til nybyggeri',
    title: 'Opbygning af sandpude forud for støbning',
    description: 'Omhyggelig afrømning af muld og lagvis komprimering af råjord og sand for maksimal bæreevne.',
  },
  'imgi-15-opbygning-af-sandpude.jpg': {
    alt: 'Komprimering og laseropbygning af stabil sandpude til nybyggeri',
    title: 'Opbygning af sandpude forud for støbning',
    description: 'Omhyggelig afrømning af muld og lagvis komprimering af råjord og sand for maksimal bæreevne.',
  },
  'sandpude-opbygning-og-afretning.jpg': {
    alt: 'Præcisionsarbejde med laserudstyr ved opbygning af sandpude til parcelhus',
    title: 'Laserafrettet sandpude til husbyggeri',
    description: 'Nøjagtig opbygning og måling af sandpude sikrer et fejlfrit og sætningsfrit fundament til huset.',
  },
  'imgi-32-opbygning-af-sandpude.jpg': {
    alt: 'Præcisionsarbejde med laserudstyr ved opbygning af sandpude til parcelhus',
    title: 'Laserafrettet sandpude til husbyggeri',
    description: 'Nøjagtig opbygning og måling af sandpude sikrer et fejlfrit og sætningsfrit fundament til huset.',
  },

  // Belægning, ridebane, veje
  'belaegning-og-flisearbejde.jpg': {
    alt: 'Nyanlagt flisebelægning med snorlige fuger og korrekt fald væk fra bygning',
    title: 'Flisebelægning og anlægsarbejde',
    description: 'Solid og slidstærk flisebelægning opbygget på komprimeret bærelag med professionel afvanding.',
  },
  'imgi-20-belaegning.jpg': {
    alt: 'Nyanlagt flisebelægning med snorlige fuger og korrekt fald væk fra bygning',
    title: 'Flisebelægning og anlægsarbejde',
    description: 'Solid og slidstærk flisebelægning opbygget på komprimeret bærelag med professionel afvanding.',
  },
  'afretning-af-ridebane.jpg': {
    alt: 'Millimeterpræcis laserafretning af underlag til ridebane med specialudstyr',
    title: 'Laserafretning og opbygning af ridebane',
    description: 'Professionel planering og laserafretning til hestefaciliteter og ridebaner for optimal fjedring og dræning.',
  },
  'imgi-21-afretning-af-ridebane-2.jpg': {
    alt: 'Millimeterpræcis laserafretning af underlag til ridebane med specialudstyr',
    title: 'Laserafretning og opbygning af ridebane',
    description: 'Professionel planering og laserafretning til hestefaciliteter og ridebaner for optimal fjedring og dræning.',
  },
  'vejanlaeg-og-pladsetablering.jpg': {
    alt: 'Vejanlæg og etablering af adgangsvej med komprimering af stabilgrus',
    title: 'Vejanlæg og anlægsarbejde',
    description: 'Opbygning af holdbare køreveje, pladser og kystsikring med maskinpark til tung jordhåndtering.',
  },
  'imgi-22-vejanlaeg.jpg': {
    alt: 'Vejanlæg og etablering af adgangsvej med komprimering af stabilgrus',
    title: 'Vejanlæg og anlægsarbejde',
    description: 'Opbygning af holdbare køreveje, pladser og kystsikring med maskinpark til tung jordhåndtering.',
  },

  // Pavilloner & underlag
  'klargoering-til-pavilloner-udgravning.jpg': {
    alt: 'Terrænregulering og udgravning forud for etablering af havepavillon',
    title: 'Klargøring af grund til pavillon',
    description: 'Nivellering af terræn og udgravning til stabil bund for havepavillon og terrasseareal.',
  },
  'imgi-24-klargoering-til-pavilionner-1.jpg': {
    alt: 'Terrænregulering og udgravning forud for etablering af havepavillon',
    title: 'Klargøring af grund til pavillon',
    description: 'Nivellering af terræn og udgravning til stabil bund for havepavillon og terrasseareal.',
  },
  'klargoering-til-pavilloner-underlag.jpg': {
    alt: 'Jordarbejde og klargøring af underlag til fundamenter og haveanlæg',
    title: 'Forberedelse af underlag til haveanlæg',
    description: 'Udgravning og afrømning af jordlag som forberedelse til udendørs konstruktioner og pavilloner.',
  },
  'imgi-25-klargoering-til-pavilionner.jpg': {
    alt: 'Jordarbejde og klargøring af underlag til fundamenter og haveanlæg',
    title: 'Forberedelse af underlag til haveanlæg',
    description: 'Udgravning og afrømning af jordlag som forberedelse til udendørs konstruktioner og pavilloner.',
  },
  'opstilling-af-havepavillon-montering.jpg': {
    alt: 'Opførelse og montering af ottekantet havepavillon på ny flisebelægning',
    title: 'Opstilling af havepavillon på terrasse',
    description: 'Fuldendt haveoase med professionelt monteret pavillon på specialtilpasset flisebelægning.',
  },
  'imgi-33-opstilling-af-pavilionner-1.jpg': {
    alt: 'Opførelse og montering af ottekantet havepavillon på ny flisebelægning',
    title: 'Opstilling af havepavillon på terrasse',
    description: 'Fuldendt haveoase med professionelt monteret pavillon på specialtilpasset flisebelægning.',
  },
  'faerdig-havepavillon-og-flisegang.jpg': {
    alt: 'Færdigbygget havepavillon med tilhørende flisebelagt gangsti og haveanlæg',
    title: 'Færdigmonteret pavillon og havemiljø',
    description: 'Samlet totalløsning med udgravning, belægning og færdig pavillonopstilling.',
  },
  'imgi-34-opstilling-af-pavilionner.jpg': {
    alt: 'Færdigbygget havepavillon med tilhørende flisebelagt gangsti og haveanlæg',
    title: 'Færdigmonteret pavillon og havemiljø',
    description: 'Samlet totalløsning med udgravning, belægning og færdig pavillonopstilling.',
  },
  'punktfundamenter-stoebt-til-pavillon.jpg': {
    alt: 'Støbning af præcise punktfundamenter i beton med stolpebærere til pavillon',
    title: 'Støbte punktfundamenter til pavillon',
    description: 'Frostsikre punktfundamenter støbt i den korrekte dybde for langvarig stabilitet.',
  },
  'imgi-35-punktfundamenter-til-pavilionner-1.jpg': {
    alt: 'Støbning af præcise punktfundamenter i beton med stolpebærere til pavillon',
    title: 'Støbte punktfundamenter til pavillon',
    description: 'Frostsikre punktfundamenter støbt i den korrekte dybde for langvarig stabilitet.',
  },
  'punktfundamenter-beton-i-plan.jpg': {
    alt: 'Færdighærdede punktfundamenter i terræn klar til montering af bærekonstruktion',
    title: 'Punktfundamenter nivelleret i plan',
    description: 'Lasernivellerede punktfundamenter sikrer, at konstruktionen hviler på et 100% plant underlag.',
  },
  'imgi-36-punktfundamenter-til-pavilionner.jpg': {
    alt: 'Færdighærdede punktfundamenter i terræn klar til montering af bærekonstruktion',
    title: 'Punktfundamenter nivelleret i plan',
    description: 'Lasernivellerede punktfundamenter sikrer, at konstruktionen hviler på et 100% plant underlag.',
  },

  // Maskinpark
  'entreprenoer-maskinpark-gravemaskiner.jpg': {
    alt: 'Entreprenør Jan Nørgaards moderne maskinpark og gravemaskiner på pladsen',
    title: 'Maskinpark til jord- og anlægsopgaver',
    description: 'Alsidig maskinpark med larvebåndsgravere og specialredskaber til både store og trange arbejdsforhold.',
  },
  'imgi-26-maskiner-1.jpg': {
    alt: 'Entreprenør Jan Nørgaards moderne maskinpark og gravemaskiner på pladsen',
    title: 'Maskinpark til jord- og anlægsopgaver',
    description: 'Alsidig maskinpark med larvebåndsgravere og specialredskaber til både store og trange arbejdsforhold.',
  },
  'moderne-entreprenoermaskiner.jpg': {
    alt: 'Tungt entreprenørmateriel og gravemaskiner klar til anlægsprojekt',
    title: 'Entreprenørmateriel og gravemaskiner',
    description: 'Pålidelige entreprenørmaskiner sikrer effektiv og præcis udførelse af alle jord- og graveopgaver.',
  },
  'imgi-27-maskiner.jpg': {
    alt: 'Tungt entreprenørmateriel og gravemaskiner klar til anlægsprojekt',
    title: 'Entreprenørmateriel og gravemaskiner',
    description: 'Pålidelige entreprenørmaskiner sikrer effektiv og præcis udførelse af alle jord- og graveopgaver.',
  },

  // Nedrivning
  'nedbrydning-med-sortergrab.jpg': {
    alt: 'Gravemaskine med sortergrab i gang med kontrolleret nedbrydning',
    title: 'Kontrolleret nedbrydningsarbejde',
    description: 'Sikker og miljømæssigt forsvarlig nedbrydning med kildesortering af materialer.',
  },
  'imgi-28-nedbrydning-1.jpg': {
    alt: 'Gravemaskine med sortergrab i gang med kontrolleret nedbrydning',
    title: 'Kontrolleret nedbrydningsarbejde',
    description: 'Sikker og miljømæssigt forsvarlig nedbrydning med kildesortering af materialer.',
  },
  'kontrolleret-nedbrydning-og-nedrivning.jpg': {
    alt: 'Nedbrydning af betonkonstruktioner og bortkørsel af murbrokker',
    title: 'Nedbrydning og materialehåndtering',
    description: 'Effektiv nedrivning af ældre bygninger og fundamenter med professionel genanvendelse.',
  },
  'imgi-30-nedbrydning-3.jpg': {
    alt: 'Nedbrydning af betonkonstruktioner og bortkørsel af murbrokker',
    title: 'Nedbrydning og materialehåndtering',
    description: 'Effektiv nedrivning af ældre bygninger og fundamenter med professionel genanvendelse.',
  },
  'nedbrydning-og-nedrivningsarbejde.jpg': {
    alt: 'Professionelt nedrivningsarbejde og terrænoprydning med gravemaskine',
    title: 'Nedbrydning og terrænoprydning',
    description: 'Miljøansvarlig nedbrydning og oprydning med professionelt entreprenørmateriel.',
  },
  'imgi-3-nedbrydning-3.jpg': {
    alt: 'Professionelt nedrivningsarbejde og terrænoprydning med gravemaskine',
    title: 'Nedbrydning og terrænoprydning',
    description: 'Miljøansvarlig nedbrydning og oprydning med professionelt entreprenørmateriel.',
  },
};

/**
 * Helper to get clean metadata for any image URL in the project.
 */
export function getImageMeta(url, fallbackTitle = '', index = 0) {
  if (!url) {
    return {
      alt: fallbackTitle || 'Entreprenør Jan Nørgaard ApS',
      title: fallbackTitle || 'Entreprenør Jan Nørgaard ApS',
      description: fallbackTitle || '',
    };
  }

  // Extract base filename from URL
  const cleanUrl = url.split('?')[0];
  const filename = cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1).toLowerCase();

  // Check direct key match
  for (const [key, meta] of Object.entries(MEDIA_REGISTRY)) {
    if (filename === key.toLowerCase() || filename.includes(key.toLowerCase()) || key.toLowerCase().includes(filename)) {
      return meta;
    }
  }

  // Fallback generation based on fallbackTitle and index
  const indexStr = index > 0 ? ` (billede ${index})` : '';
  const titleText = fallbackTitle ? `${fallbackTitle}${indexStr}` : 'Entreprenør Jan Nørgaard ApS projekt';
  return {
    alt: `${titleText} - udført af Entreprenør Jan Nørgaard ApS`,
    title: titleText,
    description: fallbackTitle ? `Dokumentation af ${fallbackTitle} udført af autoriseret kloakmester og entreprenør Jan Nørgaard.` : '',
  };
}
